var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showList)?_c('div',{staticClass:"body-l"},[_c('div',{staticClass:"mask",on:{"click":_vm.clickMask}}),_vm._l((_vm.classList),function(item){return _c('div',{key:item.name,class:{
            'body-l-item':true,
            'select-back':_vm.selectName==item.name
        },on:{"click":function($event){return _vm.getClass(item)}}},[_c('img',{attrs:{"src":item.url,"alt":""}}),_c('span',{style:({color:_vm.selectName!=item.name?'#c2c2c2':'#A48EFF'})},[_vm._v(_vm._s(item.name))])])})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }